import { useContext } from "react";
import { UnenrollmentActionContext } from "./UnenrollmentActionContext";

function useInitialize() {
  const { setElement, setShowModal } = useContext(UnenrollmentActionContext);
  return (formDefaultValues: any) => {
    setElement(formDefaultValues);
    setShowModal(true);
  };
}

export default useInitialize;
